import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@hweeks/kei-costs-ui-testids';
import { Fragment } from 'react';
import { ButtonLink } from '../../design';
import { CtaBand } from './CtaBand';
import { MountainRoad, Spot } from './illustrations';
import { MKT } from './links';
import { MarketingLayout } from './MarketingLayout';
import { NextLink, ProductDetails, ProductFaq, ProductHero, ProductSection, ProductStep, ProductSteps } from './ProductParts';
import { rows } from './ProductSearchPage.data';
import './product-search.css';
import { AnalyticsEvent, ctaEvent } from '../../utils/analytics';
// Product · 01 Auction search. Built from design-mockups/rhd-woodblock/Product-Search.dc.html.
// The searches, lots and agents shown are illustrative.
export default function ProductSearchPage() {
    return /*#__PURE__*/ _jsx(MarketingLayout, {
        testid: Testids.app.marketing.productRoot('search'),
        children: /*#__PURE__*/ _jsxs("main", {
            children: [
                /*#__PURE__*/ _jsx(ProductHero, {
                    stack: true,
                    watermark: "検",
                    k: "検索",
                    label: "Product · 01 Auction search",
                    title: "One search across your auction agents.",
                    lead: "Run it once across your agent accounts. Save it as a hunt and you’ll hear about new matches when it next runs.",
                    leadStyle: {
                        maxWidth: 620
                    },
                    actions: /*#__PURE__*/ _jsx(ButtonLink, {
                        href: MKT.signup,
                        ...ctaEvent(AnalyticsEvent.ctaSignup, 'product-search'),
                        children: "Get started"
                    }),
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "mk-product-search__search-hero-div-4",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-product-search__search-hero-div-5",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mk-product-search__search-hero-div-6",
                                        children: "Filters"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-product-search__search-hero-div-7",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-product-search__search-hero-span-2",
                                                children: "Make / model"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-product-search__search-hero-span-3",
                                                children: "Mitsubishi Delica · PE8W"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-product-search__search-hero-div-8",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-search__search-hero-div-7",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-search__search-hero-span-2",
                                                        children: "Year"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-search__search-hero-span-4",
                                                        children: "1996–2001"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-search__search-hero-div-7",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-search__search-hero-span-2",
                                                        children: "Grade"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-search__search-hero-span-4",
                                                        children: "3.5+"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-search__search-hero-div-7",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-search__search-hero-span-2",
                                                        children: "Mileage"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-search__search-hero-span-4",
                                                        children: "≤ 150,000 km"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-search__search-hero-div-7",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-search__search-hero-span-2",
                                                        children: "Trans."
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-search__search-hero-span-4",
                                                        children: "AT"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-product-search__search-hero-div-9",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-product-search__search-hero-span-5",
                                                children: "Upcoming ✓"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-product-search__search-hero-span-5",
                                                children: "All sites ✓"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mk-product-search__search-hero-div-10",
                                        children: "★ Hunt · “Delica diesel for stock” · alerts on new"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-product-search__search-hero-div-11",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-product-search__search-hero-div-12",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                children: "11 results · sorted by auction date"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                children: "JCD 5 · JDM Auc 4 · PCJ 2"
                                            })
                                        ]
                                    }),
                                    rows.map((r)=>/*#__PURE__*/ _jsx(Fragment, {
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "mk-product-search__search-hero-div-13",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "mk-product-search__search-hero-div-14",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "mk-product-search__search-hero-div-15",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "mk-product-search__search-hero-span-6",
                                                                        children: r.car
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "mk-product-search__search-hero-span-7",
                                                                        children: r.src
                                                                    }),
                                                                    r.list && /*#__PURE__*/ _jsx("span", {
                                                                        className: "mk-product-search__search-hero-span-8",
                                                                        children: "On your list"
                                                                    }),
                                                                    r.isNew && /*#__PURE__*/ _jsx("span", {
                                                                        className: "mk-product-search__search-hero-span-9",
                                                                        children: "New"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "mk-product-search__search-hero-div-16",
                                                                children: r.meta
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-product-search__search-hero-span-10",
                                                        children: r.g
                                                    })
                                                ]
                                            })
                                        }, r.car))
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spot, {
                    width: 320,
                    children: /*#__PURE__*/ _jsx(MountainRoad, {})
                }),
                /*#__PURE__*/ _jsx(ProductSection, {
                    loose: true,
                    title: "Four steps. After that it runs on its own.",
                    children: /*#__PURE__*/ _jsxs(ProductSteps, {
                        children: [
                            /*#__PURE__*/ _jsx(ProductStep, {
                                k: "壱",
                                title: "Connect your agent accounts",
                                text: "Add the logins you already use. Right Hand DMS searches through them the way you would, with no new agent and no new contract.",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-pp-step__ui mk-pp-step__ui--framed mk-product-search__how-it-works-div-4",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-product-search__how-it-works-div-5",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-search__how-it-works-span-2",
                                                    children: "JapanCarDirect"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-search__how-it-works-span-3",
                                                    children: "● Connected"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-product-search__how-it-works-div-5",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-search__how-it-works-span-2",
                                                    children: "JDM Auc"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-search__how-it-works-span-3",
                                                    children: "● Connected"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-product-search__how-it-works-div-6",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-search__how-it-works-span-2",
                                                    children: "Pacific Coast JDM"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-search__how-it-works-span-4",
                                                    children: "Connect"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(ProductStep, {
                                k: "弐",
                                title: "Filter like an importer",
                                text: "Filter on make, model, year, grade, mileage, transmission and engine size. The year starts out capped at what’s importable under the 25-year rule.",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-pp-step__ui mk-pp-step__ui--framed mk-product-search__how-it-works-div-7",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-product-search__how-it-works-span-5",
                                            children: "Toyota Hilux Surf · KZN185W"
                                        }),
                                        /*#__PURE__*/ _jsxs("span", {
                                            className: "mk-product-search__how-it-works-span-6",
                                            children: [
                                                "≤ 2001 ",
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-search__how-it-works-span-7",
                                                    children: "①"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-product-search__how-it-works-span-6",
                                            children: "Grade ≥ 3.5"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-product-search__how-it-works-span-6",
                                            children: "≤ 160,000 km"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-product-search__how-it-works-span-6",
                                            children: "AT"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-product-search__how-it-works-span-6",
                                            children: "≤ 3,000cc"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-product-search__how-it-works-div-8",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-search__how-it-works-span-8",
                                                    children: "①"
                                                }),
                                                " Model year cap from the 25-year rule. In 2026 that’s 2001 and older."
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(ProductStep, {
                                k: "参",
                                title: "One list, every source tagged",
                                text: "Results land in one list with the source on every row. Lots you’re already watching or bidding on are marked, so you won’t chase the same car twice.",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-pp-step__ui mk-pp-step__ui--framed mk-product-search__how-it-works-div-9",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-product-search__how-it-works-div-10",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-search__how-it-works-span-2",
                                                    children: "1997 Toyota Hilux Surf SSR-X 4WD"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-search__how-it-works-span-9",
                                                    children: "JDM Auc"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-search__how-it-works-span-10",
                                                    children: "On your list · Watching"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-product-search__how-it-works-div-11",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-search__how-it-works-span-2",
                                                    children: "1998 Toyota Hilux Surf SSR-G 4WD"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-product-search__how-it-works-span-9",
                                                    children: "JCD"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(ProductStep, {
                                k: "四",
                                title: "Make it a hunt and get told",
                                text: "Hunts re-run twice a day by default. When something new matches, you get one short notice, and that’s all.",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-pp-step__ui mk-pp-step__ui--framed mk-product-search__how-it-works-div-12",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-product-search__how-it-works-span-11",
                                            children: "新"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-product-search__how-it-works-div-13",
                                            children: [
                                                /*#__PURE__*/ _jsx("b", {
                                                    className: "mk-product-search__how-it-works-b",
                                                    children: "2 new matches · “Delica diesel for stock”"
                                                }),
                                                /*#__PURE__*/ _jsxs("span", {
                                                    className: "mk-product-search__how-it-works-span-12",
                                                    children: [
                                                        "1997 Delica Space Gear PE8W · 3.5 · 118,000 km",
                                                        /*#__PURE__*/ _jsx("br", {}),
                                                        "1999 Delica Space Gear PE8W · 4 · 96,000 km"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(ProductDetails, {
                    tightHeadings: true,
                    title: "Details that matter to an importer",
                    items: [
                        [
                            'Model codes, not just names',
                            'WGNC34 and WGC34 aren’t the same car. One of them is the 4WD. Search by chassis code when it matters.'
                        ],
                        [
                            'Duplicate lots merged',
                            'A lot listed on both JapanCarDirect and JDM Auc shows up once.'
                        ],
                        [
                            'Auction times in your zone',
                            'JST and your local time side by side, so you don’t miss a 1 a.m. lot.'
                        ],
                        [
                            'Your logins, your access',
                            'You see what your agent accounts can see, and no more. Logins are encrypted at rest.'
                        ]
                    ]
                }),
                /*#__PURE__*/ _jsx(ProductFaq, {
                    title: "Search questions",
                    items: [
                        [
                            'Which auction sources are supported?',
                            'JapanCarDirect, JDM Auc and Pacific Coast JDM, through your own accounts. If you use a different agent, tell us on a call.'
                        ],
                        [
                            'How often do hunts run?',
                            'Twice a day by default, at 4 a.m. and 4 p.m. Pacific. You can change that for each hunt.'
                        ],
                        [
                            'Will it show vehicles newer than the 25-year cutoff?',
                            'Only if you widen the year filter yourself. Out of the box it stops at the newest importable model year.'
                        ]
                    ]
                }),
                /*#__PURE__*/ _jsx(NextLink, {
                    label: "Next · 02",
                    title: "Auction sheets",
                    go: "査定 →",
                    href: MKT.product('auction-sheets')
                }),
                /*#__PURE__*/ _jsx(CtaBand, {})
            ]
        })
    });
}
